import React, { useEffect, useRef } from 'react';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import Message from 'semantic-ui-react/dist/commonjs/collections/Message';
import Transition from 'semantic-ui-react/dist/commonjs/modules/Transition';
import { useDispatch, useSelector } from 'react-redux';
import {
  COMMON_MESSAGE_TIMEOUT,
  HELP_CENTER,
  HELP_CENTER_PUBLIC_PROFILE_URL,
  HELP_CENTRE_CONSTANT
} from '../../utils/constants';
import { hideMessage } from '../../redux/actions/common-message/message-action';
import { Link, useNavigate } from 'react-router-dom';

import './common-message.css';
import CommonButton from '../common-button/CommonButton';
import { selectMessageReducer, selectUserSessionReducer } from '@Redux/selectors';

const CommonMessage = () => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const { message, hide, redirectURL } = useSelector(selectMessageReducer);
  const { is_user_authenticated } = useSelector(selectUserSessionReducer);
  const dispatch = useDispatch();

  const hidePopup = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    dispatch(hideMessage());
  };

  useEffect(() => {
    if (!hide) {
      timeoutRef.current = setTimeout(hidePopup, COMMON_MESSAGE_TIMEOUT);
    } else {
      hidePopup();
    }

    // Cleanup timeout on unmount
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hide]);

  const handleButtonClick = () => {
    dispatch(hideMessage());
    if (redirectURL) {
      navigate(redirectURL);
    }
  };

  let tempMsg = typeof message.text === 'string' ? message?.text : message?.text[0];
  let helpCenterMsg;

  if (tempMsg?.includes(HELP_CENTRE_CONSTANT)) {
    const firstPart = tempMsg?.substring(0, tempMsg?.indexOf(HELP_CENTRE_CONSTANT));
    const lastPart = tempMsg?.substring(
      tempMsg?.lastIndexOf(HELP_CENTRE_CONSTANT) + HELP_CENTRE_CONSTANT.length
    );
    const helpCenterLink = is_user_authenticated ? HELP_CENTER : HELP_CENTER_PUBLIC_PROFILE_URL;
    helpCenterMsg = (
      <>
        {' '}
        {firstPart}{' '}
        <Link
          to={helpCenterLink}
          onClick={() => dispatch(hideMessage())}
          className="visitHelpCenter"
        >
          Help Center
        </Link>{' '}
        {lastPart}{' '}
      </>
    );
  }

  // to show list of messages
  let listOfMsges =
    (message.text &&
      message.text.length === 1 &&
      message.text[0]?.indexOf('|') !== -1 &&
      message.text[0]?.split('|')) ||
    null;
  let renderHtml = message.renderHtml || false;

  return (
    <Transition visible={message.text.length > 0 && !hide} duration={300}>
      <Grid centered className="parent show-message">
        <Message
          className="commonMessage"
          floating
          compact
          id="common-message"
          info={message.type === 'info'}
          error={message.type === 'error'}
          success={message.type === 'success'}
          warning={message.type === 'warning'}
          onDismiss={() => dispatch(hideMessage())}
        >
          <Message.Content>
            <Grid centered className="messageParrent">
              <Grid.Row>
                <Grid.Column width={14} className={'popup-text'}>
                  {!renderHtml ? (
                    <Message.List
                      className={`${listOfMsges ? 'multiple-errors' : ''}`}
                      items={
                        helpCenterMsg ||
                        listOfMsges ||
                        (typeof message.text === 'string' ? [message.text] : message.text)
                      }
                    />
                  ) : (
                    <div dangerouslySetInnerHTML={{ __html: message.text }} />
                  )}
                </Grid.Column>
                <Grid.Column width={14}>
                  <CommonButton
                    text="Got it"
                    margin="0 auto 20px"
                    width={125}
                    height={50}
                    id="common-message-submit"
                    onClick={handleButtonClick}
                  >
                    Got it
                  </CommonButton>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Message.Content>
        </Message>
      </Grid>
    </Transition>
  );
};

export default CommonMessage;
